<template>
  <div style="display: inline-block;">
    <el-popover placement="bottom-start" v-model="visible">
      <eco-tree
        style="max-height:400px;width:300px;overflow: auto;"
        v-if="visible"
        :data="data"
        node-key="id"
        :expand-on-click-node="false"
        :props="defaultProps"
        support-filter
        default-expand-all
        @node-click="handleNodeClick"
      ></eco-tree>
      <el-button slot="reference">选择变量</el-button>
    </el-popover>
  </div>
</template>

<script>
import req from "@/request.js";
import { mapState, mapActions } from "vuex";
import utils from "@/eco-ui-util.js";
export default {
  props: ["boKey"],
  components: {},
  data() {
    return {
      visible: false,
      dialogVisible: false,
      data: [],
      defaultProps: {
        children: "children",
        label: "desc"
      },
      thisDefId: ""
    };
  },
  watch: {
    boKey: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          let this_ = this;
          this_.defaultProps = {
            children: "children",
            label: "desc"
          };
          req
            .get(
              req.getContext().form +
                "/form/formServiceController/v1/getAttrListByDefId?defId=" +
                newVal
            )
            .then(response => {
              this_.data = response.data;
            });
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: mapState({
    defConfigData: state => state.flow.defConfigData
  }),
  methods: {
    handleNodeClick(selection, node, nodeCompent) {
      if (selection && selection.children && selection.children.length > 0) {
        return;
      }
      this.visible = false;
      this.handleValue(node, selection);
      this.$emit("node-click", selection, node);
    },
    handleValue(node, selection) {
      var keyStr = node.data.name;

      keyStr = "{" + node.data.desc + ":" + this.boKey + "." + keyStr + "}";
      node.data.pathValue = keyStr;
      selection.pathValue = keyStr;
      this.$emit("input", keyStr);
    }
  },
  created() {
    this.utils = utils;
    let this_ = this;
    this_.data = [];

    req
      .get(
        req.getContext().form +
          "/form/formServiceController/v1/getAttrListByDefId?defId=" +
          this.boKey
      )
      .then(response => {
        this_.data = response.data;
      });
  }
};
</script>

<style scoped>
div >>> .el-dialog__body {
  padding: 10px;
}

.table > thead > tr > th,
.table > thead > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #e7eaec;
  border-left: 1px solid #e7eaec;
  line-height: 1.42857;
  padding: 8px;
  vertical-align: middle;
}
.table {
  border-bottom: 1px solid #e7eaec;
  border-right: 1px solid #e7eaec;
}
.table >>> .el-button {
  padding: 6px 8px;
  margin-left: 0px;
  margin-right: 5px;
}
div >>> .el-tabs__content {
  height: 450px;
  overflow: auto;
}
</style>
